<template>
    <div class="my-foot">
        <div>辽宁交投e工会</div>
        <div>交投集团</div>
    </div>
</template>

<script>
    export default {
        name: "footTM"
    }
</script>

<style scoped lang="less">
    .my-foot {
        position: fixed;
        bottom: 3rem;
        text-align: center;
        width: 100%;
        color: #aaabac;
        font-size: 0.5rem;
        margin-bottom: 1rem;

        div {
            margin: 0.3rem;
        }
    }
</style>